import { render, staticRenderFns } from "./LocationViewGlobal.vue?vue&type=template&id=0ca1f1a6&"
import script from "./LocationViewGlobal.vue?vue&type=script&lang=js&"
export * from "./LocationViewGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports